import React, { Component } from "react";
import Switch from "react-switch";
import { fire } from "../../firebase/index";

import { customLog } from "../../variables/Variables";

class SwitchBtn extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    let prop = this.props.hasAdminRights;
    const userEmail = prop.userEmail;
    const isAdmin = prop.isAdmin;
    const superAdminID = prop.superAdminID;
    const isSuperAdmin = prop.isSuperAdmin;

    this.state = {
      isSuperAdmin: isSuperAdmin,
      userEmail: userEmail,
      isAdmin: isAdmin,
      superAdminID: superAdminID,
    };
  }

  handleChange(checked, event, id) {
    let isAdmin = this.state.isAdmin;
    let email = this.state.userEmail;
    const superAdmin = this.state.superAdminID;

    // customLog(isAdmin);
    // customLog(superAdmin);
    // customLog(email);

    customLog(this.state);

    const db = fire.database();

    db.ref("groupAccounts/" + superAdmin + "/members")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((member) => {
          // customLog(member);
          const memberVal = member.val();

          // customLog(memberVal);
          // customLog(memberVal.key);

          if (memberVal.memberEmail === email) {
            const memberKey = member.key;
            // customLog(memberKey);
            db.ref(
              "groupAccounts/" + superAdmin + "/members/" + memberKey
            ).update({
              isAdmin: !isAdmin,
            });
          }
        });
      });

    this.setState({ isAdmin: !isAdmin });
  }

  render() {
    // const superAdminEmail = this.state.superAdminEmail;
    return (
      <Switch
        onChange={this.handleChange}
        checked={this.state.isAdmin}
        disabled={this.state.isSuperAdmin}
        id="normal-switch"
      />
    );
  }
}

export default SwitchBtn;
